export default __webpack_public_path__ + "static/media/icon-ob-kb.1b27cb24.svg";